import React, { useContext, useEffect, useState } from 'react'
import { Alert, Button, DatePicker, Form, Input, Layout, Menu, message, Tabs, TabsProps } from 'antd'
import { getRequestAuth, postRequestAuth, putRequestAuth } from '../../../request/request';
import moment from 'moment';
import { AppContext } from '../../../App';
import { ContextType } from '../../../type/type';
import { useTranslation } from 'react-i18next';
import validatorServerErrors from '../../../modules/ValidatorServerErrors/ValidatorServerErrors';
import { JWT, ME } from '../../../reduser/Reduser';
import { useLocation, useNavigate } from 'react-router-dom'
import { validateAge } from '../../../function/validateAge';
import '../style/styleProfile.scss'
import BottomMenuInfo from '../../../modules/BottomMenuInfo/BottomMenuInfo';

type FieldType = {
  username?: string
  password?: string
  remember?: string
}

const Password = () => {
  const { state, dispatch, isMobileWidth } = useContext<ContextType>(AppContext)
  const { t } = useTranslation()
  const [about_me] = Form.useForm();
  const [form_phone] = Form.useForm()
  const [form_email] = Form.useForm()
  const [form_password] = Form.useForm()
  const [form_change_phone] = Form.useForm()
  const [userId, setUserId] = useState(null)
  const [dateBirthday, setDateBirthday] = useState(null)
  const [userPhone, setUserPhone] = useState(null)
  const [reload, setReload] = useState(false)
  const [validateErrors, setValidateErrors]: any = useState({})
  const [isLoading, setLoading] = useState(false)
  const [step, setStep] = useState(1)
  const dateFormat = 'YYYY-MM-DD'
  const dateFormatCalendar = ['YYYY-MM-DD', 'DD.MM.YYYY']
  const navigate = useNavigate()

  useEffect(() => {
    getRequestAuth('/profile/about_me/')
      .then((res: any) => {
        const {
          first_name,
          last_name,
          middle_name,
          date_birthday,
          user: { id, phone, email },
        } = res?.data || {}

      const newDate: any = moment(date_birthday, dateFormat)

      setUserId(id)
      setDateBirthday(date_birthday)

      about_me.setFieldsValue({
        first_name,
        last_name,
        middle_name,
        date_birthday: date_birthday ? newDate : '',
      })

      form_email.setFieldsValue({
        email,
      })

      setUserPhone(phone)
      form_phone.setFieldsValue({
        phone,
      })
    })
    .catch((err) => {
      validatorServerErrors(err.data)
      dispatch({
        type: JWT,
        payload: null,
      })
      navigate('/cabinet')
    })
  }, [reload, state.lang])

  const onFinishFailed = (errorInfo: any) => {
    console.log('errorInfo', errorInfo)
  }

  const disabledDate = (current: any) => {
    const minDate = new Date(1900, 0, 1)
    const maxDate = moment()
    return current && (current < minDate || current > maxDate)
  }

  const convertDate = (value: any) => {
    return moment(value).format(dateFormat)
  }
    
  const onFinish = (values: any, type: string) => {
    console.log(type)
    setLoading(true)
  
    if (type === 'form_password') {
      postRequestAuth('/profile/change_password/', values)
        .then((res) => {
          message.success(res?.data?.status)
          setLoading(false)
          // removeCookiesWithRetries({
          //   cookieNames: ['jwt', 'refresh'],
          //   maxRetries: 10,
          //   delay: 100,
          //   cookies,
          //   removeCookie,
          //   navigate,
          //   dispatch,
          // })
          // navigate('/')
        })
        .catch((err) => {
          validatorServerErrors(err.data, setValidateErrors)
          setLoading(false)
        })
    }
    }

  return (
      <>
        { isMobileWidth && <h3 className='profile-title'>{t('h79')}</h3> }
        <Form
          form={form_password}
          name="basic"
          layout="vertical"
          initialValues={{ remember: true }}
          onFinish={(e) => onFinish(e, 'form_password')}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <Form.Item<FieldType>
            label={t('h66')}
            name="password"
            rules={[{ required: true, message: `${t('h48')} ${t('h66')}` }]}
            validateStatus={validateErrors?.password ? 'error' : ''}
            help={validateErrors?.password}
          >
            <Input.Password />
          </Form.Item>
        
          <Form.Item<FieldType>
            label={t('h51')}
            name="new_password"
            rules={[{ required: true, message: `${t('h48')} ${t('h51')}` }]}
            validateStatus={validateErrors?.new_password ? 'error' : ''}
            help={validateErrors?.new_password}
          >
            <Input.Password />
          </Form.Item>
        
          <Form.Item
            name="confirm_password"
            label={t('h55')}
            dependencies={['new_password']}
            hasFeedback
            rules={[
              {
                required: true,
                message: `${t('h68')} ${t('h51')}`,
              },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('new_password') === value) {
                    return Promise.resolve()
                  }
                  return Promise.reject(new Error(t('h69')))
                },
              }),
            ]}
            validateStatus={validateErrors?.confirm_password ? 'error' : ''}
            help={validateErrors?.confirm_password}
          >
            <Input.Password />
          </Form.Item>
        
          <div className="text-center">
            <Button 
              type="primary"
              htmlType="submit"
              className={ isMobileWidth ? 'mobile-button-submit' : 'color_btn'}>
                {t('h81')}
            </Button>
          </div>
        </Form>
        { isMobileWidth && <BottomMenuInfo type="man" /> }
      </>
    )
}

export default Password
